import { changeState, commonModalSetting } from "JS/common";
import { useEffect, useState } from "react";
import MarkImageNameEditModal from "./Agencies/MarkImageNameEditModal";
import AddApplicationTypeModal from "./Agencies/AddApplicationTypeModal";
import { generateCompoundImage, generateImage } from "utils/imageGenerator";
import CommonModal from "./CommonModal";
import { useNavigate } from "react-router-dom";
import { useDaumPostcodePopup } from "react-daum-postcode";
import { addAgencyDetail, getIdExists, getUploadFile } from "JS/API";

const AddApplicationDetail = () => {
  const navigate = useNavigate();
  const [edit, setEdit] = useState({
    progress: false,
    markName: false,
    markType: false,
    applicationNumber: false,
    customerNumber: false,
  });

  const [modal, setModal] = useState({
    addAmount: false,
    applicationType: false,
  });

  const [alert, setAlert] = useState("");
  const [alertBox, setAlertBox] = useState({
    mode: "",
    context: "",
    bool: false,
  });

  // 상표 유형
  const [markType, setMarkType] = useState("");
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState("");
  const [img, setImg] = useState("");
  const [originalFileName, setOriginalFileName] = useState("");
  const [imagePath, setImagePath] = useState("");
  const [, setUploadComplete] = useState(false);
  const [markNameArr, setMarkNameArr] = useState([]);
  const [compoundImageFilename, setCompoundImageFilename] = useState("");
  const [compoundImagePath, setCompoundImagePath] = useState("");

  // 상품명
  const [editAddProduct, setEditAddProduct] = useState(false);
  const [detailItems, setDetailItems] = useState([]);

  // 출원인 정보
  const [nameKor, setNameKor] = useState("");
  const [nameEng, setNameEng] = useState("");
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [telNumber, setTelNumber] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [address, setAddress] = useState("");
  const [detailAddress, setDetailAddress] = useState("");
  const [bizLicenseOriginalFilename, setBizLicenseOriginalFilename] =
    useState("");
  const [bizLicenseFilename, setBizLicenseFilename] = useState("");
  const [bizLicensePath, setBizLicensePath] = useState("");
  const [
    stampCertificateOriginalFilename,
    setStampCertificateOriginalFilename,
  ] = useState("");
  const [stampCertificateFilename, setStampCertificateFilename] = useState("");
  const [stampCertificatePath, setStampCertificatePath] = useState("");
  const [stampOriginalFilename, setStampOriginalFilename] = useState("");
  const [stampFilename, setStampFilename] = useState("");
  const [stampPath, setStampPath] = useState("");
  const [corpRegistNumber, setCorpRegistNumber] = useState("");
  const [bizRegistNumber, setBizRegistNumber] = useState("");
  const [representativeName, setRepresentativeName] = useState("");
  const [
    representativeSocialSecurityNumber,
    setRepresentativeSocialSecurityNumber,
  ] = useState("");
  const [country, setCountry] = useState("");
  const [foreignerRegisterCardYn, setForeignerRegisterCardYn] = useState("y");
  const [
    foreignerRegisterCardFrontOriginalFilename,
    setForeignerRegisterCardFrontOriginalFilename,
  ] = useState("");
  const [
    foreignerRegisterCardFrontFilename,
    setForeignerRegisterCardFrontFilename,
  ] = useState("");
  const [foreignerRegisterCardFrontPath, setForeignerRegisterCardFrontPath] =
    useState("");
  const [
    foreignerRegisterCardBackOriginalFilename,
    setForeignerRegisterCardBackOriginalFilename,
  ] = useState("");
  const [
    foreignerRegisterCardBackFilename,
    setForeignerRegisterCardBackFilename,
  ] = useState("");
  const [foreignerRegisterCardBackPath, setForeignerRegisterCardBackPath] =
    useState("");
  const [foreignerRegisterNumber, setForeignerRegisterNumber] = useState("");
  const [passportOriginalFilename, setPassportOriginalFilename] = useState("");
  const [passportFilename, setPassportFilename] = useState("");
  const [passportPath, setPassportPath] = useState("");
  const [passportNumber, setPassportNumber] = useState("");
  const [overseasAddress, setOverseasAddress] = useState("");
  const [signatureOriginalFilename, setSignatureOriginalFilename] =
    useState("");
  const [signatureFilename, setSignatureFilename] = useState("");
  const [signaturePath, setSignaturePath] = useState("");

  const [applicantType, setApplicantType] = useState("dom_indiv");

  const [applicationNumber, setApplicationNumber] = useState("");


  const open = useDaumPostcodePopup();

  // 주소 찾기
  const addressHandlingFn = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") extraAddress += data.bname;
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }
    setZipCode(data.zonecode);
    setAddress(fullAddress);
  };

  const openPostModal = () => {
    open({
      onComplete: addressHandlingFn,
      top: window.innerHeight / 2 - 200,
      left: window.innerWidth / 2 - 300,
      width: 600,
      height: 600,
    });
  };

  const addDetailItem = (newItem) => {
    setDetailItems((prevItems) => {
      const exists = prevItems.some(
        (item) => item.mark_class === newItem.mark_class
      );

      if (exists) {
        return prevItems.map((item) =>
          item.mark_class === newItem.mark_class ? newItem : item
        );
      } else {
        return [...prevItems, newItem];
      }
    });
  };

  const removeDetailItem = (mark_class) => {
    setDetailItems((prev) =>
      prev.filter((item) => item.mark_class !== mark_class)
    );
  };

  const resetAllFields = () => {
    // 모든 입력 필드 초기화
    setNameKor("");
    setNameEng("");
    setSocialSecurityNumber("");
    setEmail("");
    setPhoneNumber("");
    setTelNumber("");
    setZipCode("");
    setAddress("");
    setDetailAddress("");
    setApplicationNumber("");

    // 파일 관련 필드 초기화
    setBizLicenseOriginalFilename("");
    setBizLicenseFilename("");
    setBizLicensePath("");
    setStampCertificateOriginalFilename("");
    setStampCertificateFilename("");
    setStampCertificatePath("");
    setStampOriginalFilename("");
    setStampFilename("");
    setStampPath("");

    // 법인 관련 필드 초기화
    setCorpRegistNumber("");
    setBizRegistNumber("");
    setRepresentativeName("");
    setRepresentativeSocialSecurityNumber("");

    setCountry("");
    setForeignerRegisterCardYn("y");
    setForeignerRegisterCardFrontOriginalFilename("");
    setForeignerRegisterCardFrontFilename("");
    setForeignerRegisterCardFrontPath("");
    setForeignerRegisterCardBackOriginalFilename("");
    setForeignerRegisterCardBackFilename("");
    setForeignerRegisterCardBackPath("");
    setForeignerRegisterNumber("");
    setPassportOriginalFilename("");
    setPassportFilename("");
    setPassportPath("");
    setPassportNumber("");
    setOverseasAddress("");
    setSignatureOriginalFilename("");
    setSignatureFilename("");
    setSignaturePath("");
  };
  // 추가 인지 아닌지 구분
  const [isNew] = useState(true);

  useEffect(() => {
    const updateCanvasImage = async () => {
      if (markType === "COMPOUND" && img && markNameArr.length > 0) {
        try {
          const combinedImg = await generateCompoundImage(
            img,
            markNameArr,
            setCompoundImageFilename,
            setCompoundImagePath
          );
          setImg(combinedImg);
        } catch (e) {
          console.error("복합 이미지 생성 실패:", e);
        }
      } else if (markType === "TEXT" && markNameArr.length > 0) {
        try {
          const markNames = markNameArr.map((item) =>
            typeof item === "string" ? item : item.mark_name
          );
          const imageDataUrl = generateImage(
            markNames,
            setImagePath,
            setFileName);
          setImg(imageDataUrl);
        } catch (e) {
          console.error("문자상표 이미지 생성 실패:", e);
        }
      }
    };

    updateCanvasImage();
  }, [markType, markNameArr]);

  const RenderApplicantInfo = () => {
    return (
      <div className="table-wrap applicant-info">
        <table>
          <colgroup>
            <col width="15%" />
            <col width="35%" />
            <col width="15%" />
            <col width="35%" />
          </colgroup>
          {/* 국내개인일 때 */}
          {applicantType === "dom_indiv" && (
            <>
              <thead>
                <tr>
                  <th className="title">특허 고객 구분</th>
                  <th>
                    <select
                      value={applicantType}
                      onChange={(e) => {
                        resetAllFields();
                        setApplicantType(e.target.value);
                      }}
                      style={{ width: "150px", height: "30px" }}
                    >
                      <option value="dom_indiv">국내 개인</option>
                      <option value="dom_corp">국내 법인</option>
                      <option value="fgn_indiv">외국 개인</option>
                      <option value="fgn_corp">외국 법인</option>
                      <option value="dom_inst">국가기관</option>
                    </select>
                  </th>
                  <th className="title">특허고객번호</th>
                  <th>
                    <input
                      type="text"
                      value={applicationNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          formattedValue = digits.substring(0, 1);

                          if (digits.length > 1) {
                            formattedValue +=
                              "-" +
                              digits.substring(1, Math.min(5, digits.length));

                            if (digits.length > 5) {
                              formattedValue +=
                                "-" +
                                digits.substring(
                                  5,
                                  Math.min(11, digits.length)
                                );

                              if (digits.length > 11) {
                                formattedValue +=
                                  "-" + digits.substring(11, 12);
                              }
                            }
                          }
                        }

                        if (digits.length <= 12) {
                          setApplicationNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="특허고객번호"
                      maxLength="14"
                    />
                  </th>
                </tr>
                <tr>
                  <th className="title">주민등록번호</th>
                  <th>
                    <input
                      type="text"
                      value={socialSecurityNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        let formattedValue = value;

                        const digits = value.replace(/-/g, "");

                        if (digits.length <= 13) {
                          if (digits.length > 6) {
                            formattedValue = `${digits.substring(
                              0,
                              6
                            )}-${digits.substring(6)}`;
                          } else {
                            formattedValue = digits;
                          }

                          setSocialSecurityNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="주민등록번호"
                      maxLength="14"
                    />
                  </th>
                  <th className="title">이름</th>
                  <th>
                    <div className="column">
                      <div className="row">
                        <p>국문 : </p>

                        <input
                          type="text"
                          value={nameKor}
                          onChange={(e) => setNameKor(e.target.value)}
                          placeholder="국문 이름"
                          style={{
                            marginBottom: "4px",
                            width: "200px",
                            height: "30px",
                          }}
                        />
                      </div>
                      <div className="row">
                        <p>영문 : </p>
                        <input
                          type="text"
                          value={nameEng}
                          onChange={(e) => setNameEng(e.target.value)}
                          placeholder="영문 이름"
                          style={{ width: "200px", height: "30px" }}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="title">등본상 주소</td>
                  <td>
                    <div className="row">
                      <input
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="주소"
                        style={{
                          width: "calc(100% - 70px)",
                          height: "30px",
                          marginBottom: "4px",
                        }}
                      />
                      <button onClick={openPostModal}>찾기</button>
                    </div>
                    <input
                      type="text"
                      value={zipCode}
                      onChange={(e) => setZipCode(e.target.value)}
                      placeholder="우편번호"
                      readOnly
                      style={{
                        width: "100%",
                        height: "30px",
                        marginBottom: "4px",
                      }}
                    />
                    <input
                      type="text"
                      value={detailAddress}
                      onChange={(e) => setDetailAddress(e.target.value)}
                      placeholder="상세주소"
                      style={{ width: "100%", height: "30px" }}
                    />
                  </td>
                  <td className="title">이메일</td>
                  <td>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="이메일 주소"
                      style={{ width: "100%", height: "30px" }}
                    />
                  </td>
                </tr>
                <tr>
                  <td className="title">휴대전화</td>
                  <td>
                    <input
                      type="text"
                      value={phoneNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");
                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          if (digits.length <= 3) {
                            formattedValue = digits;
                          } else if (digits.length <= 7) {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3)}`;
                          } else {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3, 7)}-${digits.substring(
                              7,
                              11
                            )}`;
                          }
                        }

                        if (digits.length <= 11) {
                          setPhoneNumber(formattedValue);
                        }
                      }}
                      placeholder="010-xxxx-xxxx"
                      style={{ width: "100%", height: "30px" }}
                      maxLength="13"
                    />
                  </td>
                  <td className="title">유선전화</td>
                  <td>
                    <input
                      type="text"
                      value={telNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");
                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          const areaCodeLength = digits.startsWith("02")
                            ? 2
                            : 3;

                          const midLength = 3;
                          const lastLength = 4;

                          if (digits.length <= areaCodeLength) {
                            formattedValue = digits;
                          } else if (
                            digits.length <=
                            areaCodeLength + midLength
                          ) {
                            formattedValue = `${digits.substring(
                              0,
                              areaCodeLength
                            )}-${digits.substring(areaCodeLength)}`;
                          } else {
                            const lastPart = digits.substring(
                              areaCodeLength + midLength
                            );
                            const limitedLastPart = lastPart.substring(
                              0,
                              lastLength
                            );

                            formattedValue = `${digits.substring(
                              0,
                              areaCodeLength
                            )}-${digits.substring(
                              areaCodeLength,
                              areaCodeLength + midLength
                            )}-${limitedLastPart}`;
                          }
                        }

                        const maxDigits = digits.startsWith("02") ? 9 : 10;

                        if (digits.length <= maxDigits) {
                          setTelNumber(formattedValue);
                        }
                      }}
                      placeholder="예: 02-000-0000"
                      style={{ width: "100%", height: "30px" }}
                      maxLength="13"
                    />
                  </td>
                </tr>
              </tbody>
            </>
          )}
          {/* 국내법인일 때 */}
          {applicantType === "dom_corp" && (
            <>
              <thead>
                <tr>
                  <th className="title">특허 고객 구분</th>
                  <th>
                    <select
                      value={applicantType}
                      onChange={(e) => {
                        resetAllFields();
                        setApplicantType(e.target.value);
                      }}
                      style={{ width: "150px", height: "30px" }}
                    >
                      <option value="dom_indiv">국내 개인</option>
                      <option value="dom_corp">국내 법인</option>
                      <option value="fgn_indiv">외국 개인</option>
                      <option value="fgn_corp">외국 법인</option>
                      <option value="dom_inst">국가기관</option>
                    </select>
                  </th>
                  <>
                    <th className="title">특허고객번호</th>
                    <th>
                      <input
                        type="text"
                        value={applicationNumber}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^\d-]/g, "");

                          const digits = value.replace(/-/g, "");

                          let formattedValue = "";

                          if (digits.length > 0) {
                            formattedValue = digits.substring(0, 1);

                            if (digits.length > 1) {
                              formattedValue +=
                                "-" +
                                digits.substring(1, Math.min(5, digits.length));

                              if (digits.length > 5) {
                                formattedValue +=
                                  "-" +
                                  digits.substring(
                                    5,
                                    Math.min(11, digits.length)
                                  );

                                if (digits.length > 11) {
                                  formattedValue +=
                                    "-" + digits.substring(11, 12);
                                }
                              }
                            }
                          }

                          if (digits.length <= 12) {
                            setApplicationNumber(formattedValue);
                          }
                        }}
                        style={{ width: "200px", height: "30px" }}
                        placeholder="특허고객번호"
                        maxLength="14"
                      />
                    </th>
                  </>
                </tr>
                <tr>
                  <th className="title">법인 등록번호</th>
                  <th>
                    <input
                      type="text"
                      value={corpRegistNumber}
                      onChange={(e) => setCorpRegistNumber(e.target.value)}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="법인 등록번호"
                    />
                  </th>
                  <th className="title">이름</th>
                  <th>
                    <div className="column">
                      <div className="row">
                        <p>국문 : </p>

                        <input
                          type="text"
                          value={nameKor}
                          onChange={(e) => setNameKor(e.target.value)}
                          placeholder="국문 이름"
                          style={{
                            marginBottom: "4px",
                            width: "200px",
                            height: "30px",
                          }}
                        />
                      </div>
                      <div className="row">
                        <p>영문 : </p>
                        <input
                          type="text"
                          value={nameEng}
                          onChange={(e) => setNameEng(e.target.value)}
                          placeholder="영문 이름"
                          style={{ width: "200px", height: "30px" }}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th className="title">대표자 주민등록번호</th>
                  <th>
                    <input
                      type="text"
                      value={socialSecurityNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        let formattedValue = value;

                        const digits = value.replace(/-/g, "");

                        if (digits.length <= 13) {
                          if (digits.length > 6) {
                            formattedValue = `${digits.substring(
                              0,
                              6
                            )}-${digits.substring(6)}`;
                          } else {
                            formattedValue = digits;
                          }

                          setSocialSecurityNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="주민등록번호"
                      maxLength="14"
                    />
                  </th>
                  <th className="title">대표자 이름</th>
                  <th>
                    <input
                      type="text"
                      value={representativeName}
                      onChange={(e) => setRepresentativeName(e.target.value)}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="대표자 이름"
                    />
                  </th>
                </tr>
                <tr>
                  <th className="title">사업자 등록번호</th>
                  <th>
                    <input
                      type="text"
                      value={bizRegistNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          if (digits.length <= 3) {
                            formattedValue = digits;
                          } else if (digits.length <= 5) {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3)}`;
                          } else {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3, 5)}-${digits.substring(
                              5
                            )}`;
                          }
                        }

                        if (digits.length <= 10) {
                          setBizRegistNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="사업자 등록번호"
                      maxLength="12"
                    />
                  </th>
                  <td className="title">법인 대표 이메일</td>
                  <td>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="이메일 주소"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="title">법인 대표 휴대전화</td>
                  <td>
                    <input
                      type="text"
                      value={phoneNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");
                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          if (digits.length <= 3) {
                            formattedValue = digits;
                          } else if (digits.length <= 7) {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3)}`;
                          } else {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3, 7)}-${digits.substring(
                              7,
                              11
                            )}`;
                          }
                        }

                        if (digits.length <= 11) {
                          setPhoneNumber(formattedValue);
                        }
                      }}
                      placeholder="010-xxxx-xxxx"
                      style={{ width: "100%", height: "30px" }}
                      maxLength="13"
                    />
                  </td>
                  <td className="title">법인 대표 유선전화</td>
                  <td>
                    <input
                      type="text"
                      value={telNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");
                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          const areaCodeLength = digits.startsWith("02")
                            ? 2
                            : 3;

                          const midLength = 3;
                          const lastLength = 4;

                          if (digits.length <= areaCodeLength) {
                            formattedValue = digits;
                          } else if (
                            digits.length <=
                            areaCodeLength + midLength
                          ) {
                            formattedValue = `${digits.substring(
                              0,
                              areaCodeLength
                            )}-${digits.substring(areaCodeLength)}`;
                          } else {
                            const lastPart = digits.substring(
                              areaCodeLength + midLength
                            );
                            const limitedLastPart = lastPart.substring(
                              0,
                              lastLength
                            );

                            formattedValue = `${digits.substring(
                              0,
                              areaCodeLength
                            )}-${digits.substring(
                              areaCodeLength,
                              areaCodeLength + midLength
                            )}-${limitedLastPart}`;
                          }
                        }

                        const maxDigits = digits.startsWith("02") ? 9 : 10;

                        if (digits.length <= maxDigits) {
                          setTelNumber(formattedValue);
                        }
                      }}
                      placeholder="예: 02-000-0000"
                      style={{ width: "100%", height: "30px" }}
                      maxLength="13"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="title">주소</td>
                  <td>
                    <div className="row">
                      <input
                        type="text"
                        value={address}
                        onChange={(e) => {
                          <input
                            type="text"
                            value={telNumber}
                            onChange={(e) => {
                              const value = e.target.value.replace(
                                /[^\d-]/g,
                                ""
                              );

                              const digits = value.replace(/-/g, "");
                              let formattedValue = "";

                              if (digits.length > 0) {
                                const areaCodeLength = digits.startsWith("02")
                                  ? 2
                                  : 3;

                                if (digits.length <= areaCodeLength) {
                                  formattedValue = digits;
                                } else if (
                                  digits.length <=
                                  areaCodeLength + 4
                                ) {
                                  formattedValue = `${digits.substring(
                                    0,
                                    areaCodeLength
                                  )}-${digits.substring(areaCodeLength)}`;
                                } else {
                                  formattedValue = `${digits.substring(
                                    0,
                                    areaCodeLength
                                  )}-${digits.substring(
                                    areaCodeLength,
                                    areaCodeLength + 4
                                  )}-${digits.substring(
                                    areaCodeLength + 4,
                                    areaCodeLength + 8
                                  )}`;
                                }
                              }

                              if (digits.length <= 12) {
                                setTelNumber(formattedValue);
                              }
                            }}
                            placeholder="02-xxxx-xxxx"
                            style={{ width: "100%", height: "30px" }}
                            maxLength="13"
                          />;
                          setAddress(e.target.value);
                        }}
                        placeholder="주소"
                        style={{
                          width: "calc(100% - 70px)",
                          height: "30px",
                          marginBottom: "4px",
                        }}
                      />
                      <button onClick={openPostModal}>찾기</button>
                    </div>
                    <input
                      type="text"
                      value={zipCode}
                      onChange={(e) => setZipCode(e.target.value)}
                      placeholder="우편번호"
                      style={{
                        width: "100%",
                        height: "30px",
                        marginBottom: "4px",
                      }}
                    />
                    <input
                      type="text"
                      value={detailAddress}
                      onChange={(e) => setDetailAddress(e.target.value)}
                      placeholder="상세주소"
                      style={{ width: "100%", height: "30px" }}
                    />
                  </td>
                  <td className="title">법인 인감</td>
                  <td>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label
                        htmlFor="stampUpload"
                        style={{
                          display: "inline-block",
                          padding: "8px 12px",
                          backgroundColor: "#444",
                          color: "#fff",
                          borderRadius: "4px",
                          cursor: "pointer",
                          width: "fit-content",
                        }}
                      >
                        파일 선택
                      </label>
                      <input
                        id="stampUpload"
                        type="file"
                        style={{ display: "none" }}
                        accept="image/*,.pdf"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setStampOriginalFilename(file.name);
                            setStampFilename(file.name);

                            const formData = new FormData();
                            formData.append("file_type", "domestic_corp_stamp");
                            formData.append("files", file);

                            try {
                              const response = await getUploadFile(formData);
                              if (
                                response &&
                                response.data &&
                                response.data.length > 0
                              ) {
                                const fileInfo = response.data[0];

                                setStampFilename(fileInfo.filename);
                                setStampPath(fileInfo.path);
                              }
                            } catch (error) {
                              console.error(
                                "국내 법인 인감  업로드 실패:",
                                error
                              );
                            }
                          }
                        }}
                      />
                      {stampFilename && (
                        <span
                          style={{
                            marginTop: "5px",
                            fontSize: "12px",
                            color: "#555",
                          }}
                        >
                          업로드된 파일: {stampOriginalFilename}
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </>
          )}
          {/* 외국개인일 때 */}
          {applicantType === "fgn_indiv" && (
            <>
              <thead>
                <tr>
                  <th className="title">특허 고객 구분</th>
                  <th>
                    <select
                      value={applicantType}
                      onChange={(e) => {
                        resetAllFields();
                        setApplicantType(e.target.value);
                      }}
                      style={{ width: "150px", height: "30px" }}
                    >
                      <option value="dom_indiv">국내 개인</option>
                      <option value="dom_corp">국내 법인</option>
                      <option value="fgn_indiv">외국 개인</option>
                      <option value="fgn_corp">외국 법인</option>
                      <option value="dom_inst">국가기관</option>
                    </select>
                  </th>
                  <th className="title">특허고객번호</th>
                  <th>
                    <input
                      type="text"
                      value={applicationNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          formattedValue = digits.substring(0, 1);

                          if (digits.length > 1) {
                            formattedValue +=
                              "-" +
                              digits.substring(1, Math.min(5, digits.length));

                            if (digits.length > 5) {
                              formattedValue +=
                                "-" +
                                digits.substring(
                                  5,
                                  Math.min(11, digits.length)
                                );

                              if (digits.length > 11) {
                                formattedValue +=
                                  "-" + digits.substring(11, 12);
                              }
                            }
                          }
                        }

                        if (digits.length <= 12) {
                          setApplicationNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="특허고객번호"
                      maxLength="14"
                    />
                  </th>
                </tr>
                <tr>
                  <th className="title">외국인등록증 여부</th>
                  <th colSpan={3}>
                    <select
                      value={foreignerRegisterCardYn}
                      onChange={(e) =>
                        setForeignerRegisterCardYn(e.target.value)
                      }
                      style={{ width: "150px", height: "30px" }}
                    >
                      <option value="">선택</option>
                      <option value="y">예 (등록증 있음)</option>
                      <option value="n">아니오 (등록증 없음)</option>
                    </select>
                  </th>
                </tr>

                <tr>
                  {foreignerRegisterCardYn === "y" && (
                    <>
                      <th className="title">외국인 등록번호</th>
                      <th>
                        <input
                          type="text"
                          value={foreignerRegisterNumber}
                          onChange={(e) =>
                            setForeignerRegisterNumber(e.target.value)
                          }
                          placeholder="외국인 등록번호"
                        />
                      </th>
                    </>
                  )}
                  <th className="title">이름</th>
                  <th>
                    <div className="column">
                      <div className="row">
                        <p>국문 : </p>

                        <input
                          type="text"
                          value={nameKor}
                          onChange={(e) => setNameKor(e.target.value)}
                          placeholder="국문 이름"
                          style={{
                            marginBottom: "4px",
                            width: "200px",
                            height: "30px",
                          }}
                        />
                      </div>
                      <div className="row">
                        <p>영문 : </p>
                        <input
                          type="text"
                          value={nameEng}
                          onChange={(e) => setNameEng(e.target.value)}
                          placeholder="영문 이름"
                          style={{ width: "200px", height: "30px" }}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="title">국적</td>
                  <td>
                    <input
                      type="text"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      placeholder="국적"
                    />
                  </td>
                  <td className="title">이메일</td>
                  <td>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="이메일"
                    />
                  </td>
                </tr>

                {foreignerRegisterCardYn === "y" && (
                  <>
                    <tr>
                      <td className="title">주소</td>
                      <td>
                        <div className="row">
                          <input
                            type="text"
                            value={address}
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="주소"
                            style={{
                              width: "calc(100% - 70px)",
                              height: "30px",
                              marginBottom: "4px",
                            }}
                          />
                          <button onClick={openPostModal}>찾기</button>
                        </div>
                        <input
                          type="text"
                          value={zipCode}
                          onChange={(e) => setZipCode(e.target.value)}
                          placeholder="우편번호"
                          style={{
                            width: "100%",
                            height: "30px",
                            marginBottom: "4px",
                          }}
                        />
                        <input
                          type="text"
                          value={detailAddress}
                          onChange={(e) => setDetailAddress(e.target.value)}
                          placeholder="상세주소"
                          style={{ width: "100%", height: "30px" }}
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="title">외국인 등록증</td>
                      <td>
                        <div className="column">
                          <span>
                            외국인등록증 앞면 :
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <label
                                htmlFor="foreignerFrontUpload"
                                style={{
                                  display: "inline-block",
                                  padding: "8px 12px",
                                  backgroundColor: "#444",
                                  color: "#fff",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  width: "fit-content",
                                }}
                              >
                                파일 선택
                              </label>
                              <input
                                id="foreignerFrontUpload"
                                type="file"
                                style={{ display: "none" }}
                                accept="image/*,.pdf"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    setForeignerRegisterCardFrontOriginalFilename(
                                      file.name
                                    );
                                    setForeignerRegisterCardFrontFilename(
                                      file.name
                                    );

                                    const formData = new FormData();

                                    formData.append(
                                      "file_type",
                                      "foreigner_register_card_front"
                                    );
                                    formData.append("files", file);

                                    try {
                                      const response = await getUploadFile(
                                        formData
                                      );
                                      if (
                                        response &&
                                        response.data &&
                                        response.data.length > 0
                                      ) {
                                        const fileInfo = response.data[0];

                                        setForeignerRegisterCardFrontFilename(
                                          fileInfo.filename
                                        );
                                        setForeignerRegisterCardFrontPath(
                                          fileInfo.path
                                        );

                                      }
                                    } catch (error) {
                                      console.error(
                                        "외국인 등록증 앞면 업로드 실패:",
                                        error
                                      );
                                    }
                                  }
                                }}
                              />

                              {foreignerRegisterCardFrontFilename && (
                                <span
                                  style={{
                                    marginTop: "5px",
                                    fontSize: "12px",
                                    color: "#555",
                                  }}
                                >
                                  업로드된 파일:{" "}
                                  {foreignerRegisterCardFrontOriginalFilename}
                                </span>
                              )}
                            </div>
                          </span>
                          <span>
                            외국인등록증 뒷면 :
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <label
                                htmlFor="foreignerBackUpload"
                                style={{
                                  display: "inline-block",
                                  padding: "8px 12px",
                                  backgroundColor: "#444",
                                  color: "#fff",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  width: "fit-content",
                                }}
                              >
                                파일 선택
                              </label>
                              <input
                                id="foreignerBackUpload"
                                type="file"
                                style={{ display: "none" }}
                                accept="image/*,.pdf"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (file) {
                                    setForeignerRegisterCardBackOriginalFilename(
                                      file.name
                                    );
                                    setForeignerRegisterCardBackFilename(
                                      file.name
                                    );

                                    const formData = new FormData();

                                    formData.append(
                                      "file_type",
                                      "foreigner_register_card_back"
                                    );
                                    formData.append("files", file, file.name);

                                    try {
                                      const response = await getUploadFile(
                                        formData
                                      );
                                      if (
                                        response &&
                                        response.data &&
                                        response.data.length > 0
                                      ) {
                                        const fileInfo = response.data[0];


                                        setForeignerRegisterCardBackFilename(
                                          fileInfo.filename
                                        );
                                        setForeignerRegisterCardBackPath(
                                          fileInfo.path
                                        );

                                      }
                                    } catch (error) {
                                      console.error(
                                        "외국인 등록증 뒷면 업로드 실패:",
                                        error
                                      );
                                    }
                                  }
                                }}
                              />

                              {foreignerRegisterCardBackFilename && (
                                <span
                                  style={{
                                    marginTop: "5px",
                                    fontSize: "12px",
                                    color: "#555",
                                  }}
                                >
                                  업로드된 파일:{" "}
                                  {foreignerRegisterCardBackOriginalFilename}
                                </span>
                              )}
                            </div>
                          </span>
                        </div>
                      </td>
                      <td className="title">서명</td>
                      <td>
                        <span>
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <label
                              htmlFor="signatureUpload"
                              style={{
                                display: "inline-block",
                                padding: "8px 12px",
                                backgroundColor: "#444",
                                color: "#fff",
                                borderRadius: "4px",
                                cursor: "pointer",
                                width: "fit-content",
                              }}
                            >
                              파일 선택
                            </label>
                            <input
                              id="signatureUpload"
                              type="file"
                              style={{ display: "none" }}
                              accept="image/*,.pdf"
                              onChange={async (e) => {
                                const file = e.target.files[0];
                                if (file) {
                                  setSignatureOriginalFilename(file.name);
                                  setSignatureFilename(file.name);

                                  const formData = new FormData();
                                  formData.append(
                                    "file_type",
                                    "foreigner_signature"
                                  );
                                  formData.append("files", file);

                                  try {
                                    const response = await getUploadFile(
                                      formData
                                    );
                                    if (
                                      response &&
                                      response.data &&
                                      response.data.length > 0
                                    ) {
                                      const fileInfo = response.data[0];

                                      setSignatureFilename(fileInfo.filename);
                                      setSignaturePath(fileInfo.path);

                                    }
                                  } catch (error) {
                                    console.error(
                                      "서명 파일 업로드 실패:",
                                      error
                                    );
                                  }
                                }
                              }}
                            />
                            {signatureFilename && (
                              <span
                                style={{
                                  marginTop: "5px",
                                  fontSize: "12px",
                                  color: "#555",
                                }}
                              >
                                업로드된 파일: {signatureOriginalFilename}
                              </span>
                            )}
                          </div>
                        </span>
                      </td>
                    </tr>
                  </>
                )}
                {foreignerRegisterCardYn === "n" && (
                  <>
                    <tr>
                      <td className="title">해외 주소(영문)</td>
                      <td>
                        <input
                          type="text"
                          value={overseasAddress}
                          onChange={(e) => setOverseasAddress(e.target.value)}
                          placeholder="해외 주소(영문)"
                        />
                      </td>
                      <td className="title">여권번호</td>
                      <td>
                        <input
                          type="text"
                          value={passportNumber}
                          onChange={(e) => setPassportNumber(e.target.value)}
                          placeholder="여권번호"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td className="title">여권사본</td>
                      <td>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label
                            htmlFor="passportUpload"
                            style={{
                              display: "inline-block",
                              padding: "8px 12px",
                              backgroundColor: "#444",
                              color: "#fff",
                              borderRadius: "4px",
                              cursor: "pointer",
                              width: "fit-content",
                            }}
                          >
                            파일 선택
                          </label>
                          <input
                            id="passportUpload"
                            type="file"
                            style={{ display: "none" }}
                            accept="image/*,.pdf"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setPassportOriginalFilename(file.name);
                                setPassportFilename(file.name);
                                const formData = new FormData();

                                formData.append("file_type", "passport");
                                formData.append("files", file, file.name);

                                try {
                                  const response = await getUploadFile(
                                    formData
                                  );
                                  if (
                                    response &&
                                    response.data &&
                                    response.data.length > 0
                                  ) {
                                    const fileInfo = response.data[0];


                                    setForeignerRegisterCardBackFilename(
                                      fileInfo.filename
                                    );
                                    setForeignerRegisterCardBackPath(
                                      fileInfo.path
                                    );

                                  }
                                } catch (error) {
                                  console.error("여권사본 업로드 실패:", error);
                                }
                              }
                            }}
                          />
                          {passportFilename && (
                            <span
                              style={{
                                marginTop: "5px",
                                fontSize: "12px",
                                color: "#555",
                              }}
                            >
                              업로드된 파일: {passportOriginalFilename}
                            </span>
                          )}
                        </div>
                      </td>
                      <td className="title">서명</td>
                      <td>
                        <div
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label
                            htmlFor="signatureUpload"
                            style={{
                              display: "inline-block",
                              padding: "8px 12px",
                              backgroundColor: "#444",
                              color: "#fff",
                              borderRadius: "4px",
                              cursor: "pointer",
                              width: "fit-content",
                            }}
                          >
                            파일 선택
                          </label>
                          <input
                            id="signatureUpload"
                            type="file"
                            style={{ display: "none" }}
                            accept="image/*,.pdf"
                            onChange={async (e) => {
                              const file = e.target.files[0];
                              if (file) {
                                setSignatureOriginalFilename(file.name);
                                setSignatureFilename(file.name);
                                const formData = new FormData();

                                formData.append(
                                  "file_type",
                                  "foreigner_signature"
                                );
                                formData.append("files", file, file.name);

                                try {
                                  const response = await getUploadFile(
                                    formData
                                  );
                                  if (
                                    response &&
                                    response.data &&
                                    response.data.length > 0
                                  ) {
                                    const fileInfo = response.data[0];
                                    setForeignerRegisterCardBackFilename(
                                      fileInfo.filename
                                    );
                                    setForeignerRegisterCardBackPath(
                                      fileInfo.path
                                    );

                                  }
                                } catch (error) {
                                  console.error("서명 업로드 실패:", error);
                                }
                              }
                            }}
                          />
                          {signatureFilename && (
                            <span
                              style={{
                                marginTop: "5px",
                                fontSize: "12px",
                                color: "#555",
                              }}
                            >
                              업로드된 파일: {signatureOriginalFilename}
                            </span>
                          )}
                        </div>
                      </td>
                    </tr>
                  </>
                )}
              </tbody>
            </>
          )}
          {/* 외국법인일 때 */}
          {applicantType === "fgn_corp" && (
            <>
              <thead>
                <tr>
                  <th className="title">특허 고객 구분</th>
                  <th>
                    <select
                      value={applicantType}
                      onChange={(e) => {
                        resetAllFields();
                        setApplicantType(e.target.value);
                      }}
                      style={{ width: "150px", height: "30px" }}
                    >
                      <option value="dom_indiv">국내 개인</option>
                      <option value="dom_corp">국내 법인</option>
                      <option value="fgn_indiv">외국 개인</option>
                      <option value="fgn_corp">외국 법인</option>
                      <option value="dom_inst">국가기관</option>
                    </select>
                  </th>
                  <th className="title">특허고객번호</th>
                  <th>
                    <input
                      type="text"
                      value={applicationNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          formattedValue = digits.substring(0, 1);

                          if (digits.length > 1) {
                            formattedValue +=
                              "-" +
                              digits.substring(1, Math.min(5, digits.length));

                            if (digits.length > 5) {
                              formattedValue +=
                                "-" +
                                digits.substring(
                                  5,
                                  Math.min(11, digits.length)
                                );

                              if (digits.length > 11) {
                                formattedValue +=
                                  "-" + digits.substring(11, 12);
                              }
                            }
                          }
                        }

                        if (digits.length <= 12) {
                          setApplicationNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="특허고객번호"
                      maxLength="14"
                    />
                  </th>
                </tr>
                <tr>
                  <th className="title">대표자 이름(영문)</th>
                  <th>
                    <input
                      type="text"
                      value={representativeName}
                      onChange={(e) => setRepresentativeName(e.target.value)}
                      placeholder="대표자 영문 이름"
                    />
                  </th>
                  <th className="title">이름</th>
                  <th>
                    <div className="column">
                      <div className="row">
                        <p>국문 : </p>

                        <input
                          type="text"
                          value={nameKor}
                          onChange={(e) => setNameKor(e.target.value)}
                          placeholder="국문 이름"
                          style={{
                            marginBottom: "4px",
                            width: "200px",
                            height: "30px",
                          }}
                        />
                      </div>
                      <div className="row">
                        <p>영문 : </p>
                        <input
                          type="text"
                          value={nameEng}
                          onChange={(e) => setNameEng(e.target.value)}
                          placeholder="영문 이름"
                          style={{ width: "200px", height: "30px" }}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="title">국적</td>
                  <td>
                    <input
                      type="text"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      placeholder="국적"
                    />
                  </td>
                  <td className="title">법인 이메일</td>
                  <td>
                    <input
                      type="text"
                      value={email === "@" ? "" : email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="법인 이메일"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="title">법인 주소</td>
                  <td>
                    <input
                      type="text"
                      value={overseasAddress}
                      onChange={(e) => setOverseasAddress(e.target.value)}
                      placeholder="법인 주소(영문)"
                    />
                  </td>

                  <td className="title">대표자 서명</td>
                  <td colSpan={3}>
                    <span>
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <label
                          htmlFor="signatureUpload"
                          style={{
                            display: "inline-block",
                            padding: "8px 12px",
                            backgroundColor: "#444",
                            color: "#fff",
                            borderRadius: "4px",
                            cursor: "pointer",
                            width: "fit-content",
                          }}
                        >
                          파일 선택
                        </label>
                        <input
                          id="signatureUpload"
                          type="file"
                          style={{ display: "none" }}
                          accept="image/*,.pdf"
                          onChange={async (e) => {
                            const file = e.target.files[0];
                            if (file) {
                              setSignatureOriginalFilename(file.name);
                              setSignatureFilename(file.name);

                              const formData = new FormData();
                              formData.append(
                                "file_type",
                                "overseas_corp_signature"
                              );
                              formData.append("files", file);

                              try {
                                const response = await getUploadFile(formData);
                                if (
                                  response &&
                                  response.data &&
                                  response.data.length > 0
                                ) {
                                  const fileInfo = response.data[0];
                                  setSignatureFilename(fileInfo.filename);
                                  setSignaturePath(fileInfo.path);

                                }
                              } catch (error) {
                                console.error(
                                  "외국법인 대표자 서명 업로드 실패:",
                                  error
                                );
                              }
                            }
                          }}
                        />
                        {signatureFilename && (
                          <span
                            style={{
                              marginTop: "5px",
                              fontSize: "12px",
                              color: "#555",
                            }}
                          >
                            업로드된 파일: {signatureOriginalFilename}
                          </span>
                        )}
                      </div>
                    </span>
                  </td>
                </tr>
              </tbody>
            </>
          )}
          {/* 국가기관일 때 */}
          {applicantType === "dom_inst" && (
            <>
              <thead>
                <tr>
                  <th className="title">특허 고객 구분</th>
                  <th>
                    <select
                      value={applicantType}
                      onChange={(e) => {
                        resetAllFields();
                        setApplicantType(e.target.value);
                      }}
                      style={{ width: "150px", height: "30px" }}
                    >
                      <option value="dom_indiv">국내 개인</option>
                      <option value="dom_corp">국내 법인</option>
                      <option value="fgn_indiv">외국 개인</option>
                      <option value="fgn_corp">외국 법인</option>
                      <option value="dom_inst">국가기관</option>
                    </select>
                  </th>
                  <th className="title">특허고객번호</th>
                  <th>
                    <input
                      type="text"
                      value={applicationNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          formattedValue = digits.substring(0, 1);

                          if (digits.length > 1) {
                            formattedValue +=
                              "-" +
                              digits.substring(1, Math.min(5, digits.length));

                            if (digits.length > 5) {
                              formattedValue +=
                                "-" +
                                digits.substring(
                                  5,
                                  Math.min(11, digits.length)
                                );

                              if (digits.length > 11) {
                                formattedValue +=
                                  "-" + digits.substring(11, 12);
                              }
                            }
                          }
                        }

                        if (digits.length <= 12) {
                          setApplicationNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="특허고객번호"
                      maxLength="14"
                    />
                  </th>
                </tr>
                <tr>
                  <th className="title">
                    고유번호 <br /> (업자 등록번호)
                  </th>
                  <th>
                    <input
                      type="text"
                      value={bizRegistNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");

                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          if (digits.length <= 3) {
                            formattedValue = digits;
                          } else if (digits.length <= 5) {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3)}`;
                          } else {
                            formattedValue = `${digits.substring(
                              0,
                              3
                            )}-${digits.substring(3, 5)}-${digits.substring(
                              5
                            )}`;
                          }
                        }

                        if (digits.length <= 10) {
                          setBizRegistNumber(formattedValue);
                        }
                      }}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="사업자 등록번호"
                      maxLength="12"
                    />
                  </th>
                  <th className="title">국가/공공 기관명</th>
                  <th>
                    <div className="column">
                      <div className="row">
                        <p>국문 : </p>

                        <input
                          type="text"
                          value={nameKor}
                          onChange={(e) => setNameKor(e.target.value)}
                          placeholder="국문 이름"
                          style={{
                            marginBottom: "4px",
                            width: "200px",
                            height: "30px",
                          }}
                        />
                      </div>
                      <div className="row">
                        <p>영문 : </p>
                        <input
                          type="text"
                          value={nameEng}
                          onChange={(e) => setNameEng(e.target.value)}
                          placeholder="영문 이름"
                          style={{ width: "200px", height: "30px" }}
                        />
                      </div>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="title">주소</td>
                  <td>
                    <div className="row">
                      <input
                        type="text"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                        placeholder="주소"
                        style={{
                          width: "calc(100% - 70px)",
                          height: "30px",
                          marginBottom: "4px",
                        }}
                      />
                      <button onClick={openPostModal}>찾기</button>
                    </div>
                    <input
                      type="text"
                      value={zipCode}
                      onChange={(e) => setZipCode(e.target.value)}
                      placeholder="우편번호"
                      style={{
                        width: "100%",
                        height: "30px",
                        marginBottom: "4px",
                      }}
                    />
                    <input
                      type="text"
                      value={detailAddress}
                      onChange={(e) => setDetailAddress(e.target.value)}
                      placeholder="상세주소"
                      style={{ width: "100%", height: "30px" }}
                    />
                  </td>
                  <td className="title">기관 대표 메일</td>
                  <td>
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      style={{ width: "200px", height: "30px" }}
                      placeholder="이메일 주소"
                    />
                  </td>
                </tr>
                <tr>
                  <td className="title">유선전화</td>
                  <td>
                    <input
                      type="text"
                      value={telNumber}
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^\d-]/g, "");
                        const digits = value.replace(/-/g, "");

                        let formattedValue = "";

                        if (digits.length > 0) {
                          const areaCodeLength = digits.startsWith("02")
                            ? 2
                            : 3;

                          const midLength = 3;
                          const lastLength = 4;

                          if (digits.length <= areaCodeLength) {
                            formattedValue = digits;
                          } else if (
                            digits.length <=
                            areaCodeLength + midLength
                          ) {
                            formattedValue = `${digits.substring(
                              0,
                              areaCodeLength
                            )}-${digits.substring(areaCodeLength)}`;
                          } else {
                            const lastPart = digits.substring(
                              areaCodeLength + midLength
                            );
                            const limitedLastPart = lastPart.substring(
                              0,
                              lastLength
                            );

                            formattedValue = `${digits.substring(
                              0,
                              areaCodeLength
                            )}-${digits.substring(
                              areaCodeLength,
                              areaCodeLength + midLength
                            )}-${limitedLastPart}`;
                          }
                        }

                        const maxDigits = digits.startsWith("02") ? 9 : 10;

                        if (digits.length <= maxDigits) {
                          setTelNumber(formattedValue);
                        }
                      }}
                      placeholder="예: 02-000-0000"
                      style={{ width: "100%", height: "30px" }}
                      maxLength="13"
                    />
                  </td>
                  <td className="title">공인대장(기관인감)</td>
                  <td>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label
                        htmlFor="stampUpload"
                        style={{
                          display: "inline-block",
                          padding: "8px 12px",
                          backgroundColor: "#444",
                          color: "#fff",
                          borderRadius: "4px",
                          cursor: "pointer",
                          width: "fit-content",
                        }}
                      >
                        파일 선택
                      </label>
                      <input
                        id="stampUpload"
                        type="file"
                        style={{ display: "none" }}
                        accept="image/*,.pdf"
                        onChange={async (e) => {
                          const file = e.target.files[0];
                          if (file) {
                            setStampOriginalFilename(file.name);
                            setStampFilename(file.name);
                            const formData = new FormData();
                            formData.append(
                              "file_type",
                              "domestic_institution_stamp"
                            );
                            formData.append("files", file);

                            try {
                              const response = await getUploadFile(formData);
                              if (
                                response &&
                                response.data &&
                                response.data.length > 0
                              ) {
                                const fileInfo = response.data[0];
                                setSignatureFilename(fileInfo.filename);
                                setSignaturePath(fileInfo.path);
                              }
                            } catch (error) {
                              console.error(
                                "기관인감 파일 업로드 실패:",
                                error
                              );
                            }
                          }
                        }}
                      />
                      {stampFilename && (
                        <span
                          style={{
                            marginTop: "5px",
                            fontSize: "12px",
                            color: "#555",
                          }}
                        >
                          업로드된 파일: {stampOriginalFilename}
                        </span>
                      )}
                    </div>
                  </td>
                </tr>
              </tbody>
            </>
          )}
        </table>
      </div>
    );
  };

  const [userId, setUserId] = useState("");
  const [idExists, setIdExists] = useState(null);

  const [idChecked, setIdChecked] = useState(false);


  const checkUserId = async () => {
    if (!userId.trim()) return;

    try {
      const res = await getIdExists(userId.trim());
      setIdChecked(true);
      if (res.status === 200) {
        setIdExists(true);
      } else {
        setIdExists(false);
      }
    } catch (err) {
      console.error("아이디 확인 중 오류:", err);
      setIdExists(false);
      setIdChecked(true);
    }
  };


  const handleSubmit = async () => {
    if (!idChecked) {
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "아이디 확인을 먼저 해주세요."
      );
      return;
    }

    if (!idExists) {
      commonModalSetting(
        setAlertBox,
        true,
        "alert",
        "존재하지 않는 아이디입니다. 다시 입력해주세요."
      );
      return;
    }



    const payload = {
      user_id: userId,
      progress_status: "FilingReq",
      mark_type: markType,

      ...(markType === "COMPOUND" && {
        compound_image_filename: compoundImageFilename,
        compound_image_path: compoundImagePath,
      }),

      ...(markType !== "TEXT" && {
        image_original_filename: originalFileName || "trademark_image.jpg",
        image_filename: fileName,
        image_path: imagePath,
      }),

      company: "",
      owner: "",
      email: "",
      phone: "",

      marks: markNameArr
        .map((name) => name.trim())
        .filter((name) => name)
        .map((name, i) => ({
          mark_step: i + 1,
          mark_name: name,
        })),

      details: detailItems.map((item) => ({
        input_type: "",
        input_keyword: "",
        category: "",
        mark_class: item.mark_class,
        mark_class_name: "",
      })),

      detail_items: detailItems,

      applicant_type: applicantType,
      info_applicant: {
        name_kor: nameKor,
        name_eng: nameEng,
        social_security_number: socialSecurityNumber,
        email,
        phone_number: phoneNumber,
        tel_number: telNumber,
        zip_code: zipCode,
        address,
        detail_address: detailAddress,
        biz_license_original_filename: bizLicenseOriginalFilename,
        biz_license_filename: bizLicenseFilename,
        biz_license_path: bizLicensePath,
        stamp_certificate_original_filename: stampCertificateOriginalFilename,
        stamp_certificate_filename: stampCertificateFilename,
        stamp_certificate_path: stampCertificatePath,
        stamp_original_filename: stampOriginalFilename,
        stamp_filename: stampFilename,
        stamp_path: stampPath,
        corp_regist_number: corpRegistNumber,
        biz_regist_number: bizRegistNumber,
        representative_name: representativeName,
        representative_social_security_number:
          representativeSocialSecurityNumber,
        country,
        foreigner_register_card_yn: foreignerRegisterCardYn,
        foreigner_register_card_front_original_filename:
          foreignerRegisterCardFrontOriginalFilename,
        foreigner_register_card_front_filename:
          foreignerRegisterCardFrontFilename,
        foreigner_register_card_front_path: foreignerRegisterCardFrontPath,
        foreigner_register_card_back_original_filename:
          foreignerRegisterCardBackOriginalFilename,
        foreigner_register_card_back_filename:
          foreignerRegisterCardBackFilename,
        foreigner_register_card_back_path: foreignerRegisterCardBackPath,
        foreigner_register_number: foreignerRegisterNumber,
        passport_original_filename: passportOriginalFilename,
        passport_filename: passportFilename,
        passport_path: passportPath,
        passport_number: passportNumber,
        overseas_address: overseasAddress,
        signature_original_filename: signatureOriginalFilename,
        signature_filename: signatureFilename,
        signature_path: signaturePath,
        collection_consent: "Y",
        delegation_consent: "Y",
        patent_customer_number: applicationNumber.replace(/\D/g, "")
      },
      is_confirmed: true
    };


    try {
      const response = await addAgencyDetail(payload);

      if (response?.paid_status === "ready") {
        // commonModalSetting(
        //   setAlertBox,
        //   true,
        //   "alert",
        //   "정상적으로 처리됐습니다.",
        //   () => navigate("/agency")
        // );

        setAlert('confirmNavigate');
        commonModalSetting(
          setAlertBox,
          true,
          "confirm",
          "정상적으로 처리됐습니다."
        );
      }

    } catch (err) {
      if (err.response?.status === 422) {
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "입력값을 모두 입력해주세요."
        );
      } else {
        console.error("제출 실패", err);
        commonModalSetting(
          setAlertBox,
          true,
          "alert",
          "요청 처리 중 오류가 발생했습니다. 다시 시도해주세요."
        );
      }
    }
  };

  return (
    <>
      <div className="container">
        <div className="content-wrap agencies-detail new">
          <div className="topBar">
            <h2>NEW-APPLICATION</h2>
          </div>
          <div className="detail-page">
            <h5>신청인 정보</h5>
            <div className="customer-info">
              <div className="customer-input">
                <p>사용자 ID :</p>
                <input
                  type="text"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  placeholder="아이디 입력"
                />
                <button onClick={checkUserId}>확인</button>
              </div>

              {idExists === false && (
                <p style={{ color: "red" }}>등록되지 않는 사용자입니다.</p>
              )}
              {idExists === true && (
                <p style={{ color: "green" }}>등록된 사용자입니다.</p>
              )}
            </div>

            <h5>출원 신청 내역</h5>
            <div className="table-wrap">
              <table>
                <colgroup>
                  <col width="20%" />
                  <col width="30%" />
                  <col width="20%" />
                  <col width="30%" />
                  <col width="30%" />
                </colgroup>
                <thead>
                  <tr>
                    <th rowSpan={5} className="title">
                      출원 상표명(이미지)
                    </th>
                    <th rowSpan={5}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {img ? (
                            <img
                              src={img}
                              alt="출원 이미지"
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "contain",
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            />
                          ) : (
                            <span style={{ color: "#999", fontSize: "12px" }}>
                              이미지가 없습니다.
                            </span>
                          )}
                        </div>
                        <div>
                          {img && markType !== "FIGURE" && (
                            <button
                              style={{
                                marginTop: "8px",
                                padding: "4px 8px",
                                backgroundColor: "#434343",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                fontSize: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const link = document.createElement("a");
                                link.href = img;
                                link.download = "trademark_image.jpg";
                                link.click();
                              }}
                            >
                              이미지 다운로드
                            </button>
                          )}

                          {img && markType === "FIGURE" && (
                            <button
                              style={{
                                marginTop: "8px",
                                padding: "4px 8px",
                                backgroundColor: "#434343",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                fontSize: "12px",
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                const link = document.createElement("a");
                                link.href = img;
                                link.download = originalFileName;
                                link.click();
                              }}
                            >
                              이미지 다운로드
                            </button>
                          )}
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <th
                      rowSpan={5}
                      className="title"
                      style={{ borderBottom: "none" }}
                    >
                      출원 상표명(텍스트)
                    </th>
                    {Array(5)
                      .fill(null)
                      .map(
                        (
                          _,
                          index // 5개 이상 표시 가능
                        ) => (
                          <div
                            key={index}
                            className="mark-name-row"
                            style={{
                              borderRight: "1px solid #ccc",
                              borderBottom:
                                index === 4 ? "none" : "1px solid #ccc", // 마지막 줄일 경우 아랫선 출력하지 않음
                              padding: "9px 15px",
                              minHeight: "41px", // 높이 설정
                              display: "flex", // 가로로 정렬
                              alignItems: "center",
                              justifyContent:
                                index === 4 && !markNameArr[index]
                                  ? "flex-end"
                                  : "space-between", // 마지막 줄일 경우 버튼을 가로로 정렬
                            }}
                          >
                            {markNameArr[index] || ""}
                          </div>
                        )
                      )}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="title">상표 유형</td>
                    <td colSpan={1}>
                      <div className="row">
                        {markType === "TEXT" && "문자상표"}
                        {markType === "FIGURE" && "도형상표"}
                        {markType === "COMPOUND" && "복합상표"}
                      </div>
                    </td>
                    <td
                      className="title"
                      style={{ border: "none", padding: "0px 10px" }}
                    ></td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        padding: "9px 15px",
                        border: "1px solid #ccc",
                        borderBottom: "none",
                      }}
                    >
                      <button
                        onClick={() => changeState(setEdit, "markImage", true)}
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        상표명 수정
                      </button>
                    </div>
                  </tr>
                  <tr>
                    <td
                      rowSpan={detailItems?.length ? detailItems?.length : 1}
                      className="title"
                    >
                      <div className="row">
                        <span>상품/업종 및 출원 유형</span>
                        <button
                          onClick={() =>
                            changeState(setModal, "applicationType", true)
                          }
                        >
                          추가
                        </button>
                      </div>
                    </td>
                    {
                      <td colSpan={5}>
                        <div className="row">
                          {detailItems[0] ? (
                            (() => {
                              const {
                                mark_class,
                                apply_type,
                                notice_register_product,
                                none_register_product,
                              } = detailItems[0];

                              return (
                                <>
                                  <span>
                                    <span style={{ fontWeight: "bold" }}>
                                      {mark_class}류/{" "}
                                    </span>
                                    <span
                                      style={{
                                        fontWeight: "bold",
                                        color:
                                          apply_type === "FAST_SEARCH"
                                            ? "#3AB548"
                                            : apply_type === "SEARCH"
                                              ? "#2EAEAE"
                                              : apply_type === "FAST"
                                                ? "#F66F6F"
                                                : apply_type === "NORMAL"
                                                  ? "#D08126"
                                                  : "inherit",
                                      }}
                                    >
                                      {apply_type === "NORMAL"
                                        ? "일반"
                                        : apply_type === "SEARCH"
                                          ? "조사"
                                          : apply_type === "FAST"
                                            ? "신속"
                                            : "신속조사"}
                                      출원
                                    </span>
                                    <button
                                      onClick={() => {
                                        setEditAddProduct({
                                          kind_code: mark_class,
                                          apply_type,
                                          notice_register_product,
                                          none_register_product,
                                        });
                                        changeState(
                                          setModal,
                                          "applicationType",
                                          true
                                        );
                                      }}
                                    >
                                      수정
                                    </button>
                                    <button
                                      onClick={() => {
                                        setAlert(`confirmDelete/${mark_class}`);
                                        commonModalSetting(
                                          setAlertBox,
                                          true,
                                          "confirm",
                                          "정말 삭제하시겠습니까?"
                                        );
                                      }}
                                    >
                                      삭제
                                    </button>
                                    <br />
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: "column",
                                      }}
                                    >
                                      <div
                                        style={{
                                          fontWeight: "bold",
                                          marginTop: "10px",
                                        }}
                                      >
                                        고시 상품
                                      </div>
                                      <div
                                        style={{
                                          margin: "10px 0 10px 0",
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "5px",
                                          alignItems: "center",
                                          fontSize: "12px",
                                        }}
                                      >
                                        -{" "}
                                        {notice_register_product.map(
                                          (e, index) => (
                                            <span
                                              style={{
                                                padding: "5px",
                                                border: "1px solid #ccc",
                                                backgroundColor: "#fff",
                                                borderRadius: "5px",
                                              }}
                                              key={index}
                                            >
                                              {e}
                                            </span>
                                          )
                                        )}{" "}
                                      </div>
                                      <div
                                        style={{
                                          color: "red",
                                          fontWeight: "bold",
                                          marginTop: "10px",
                                        }}
                                      >
                                        비고시 상품
                                      </div>
                                      <div
                                        style={{
                                          margin: "10px 0 10px 0",
                                          display: "flex",
                                          flexWrap: "wrap",
                                          gap: "5px",
                                          alignItems: "center",
                                          fontSize: "12px",
                                        }}
                                      >
                                        -{" "}
                                        {detailItems[0]?.none_register_product.map(
                                          (e, index) => (
                                            <span
                                              style={{
                                                padding: "5px",
                                                border: "1px solid #ccc",
                                                backgroundColor: "#fff",
                                                borderRadius: "5px",
                                              }}
                                              key={index}
                                            >
                                              {e}
                                            </span>
                                          )
                                        )}{" "}
                                      </div>
                                    </div>
                                  </span>
                                </>
                              );
                            })()
                          ) : (
                            <>없습니다</>
                          )}
                        </div>
                      </td>
                    }
                  </tr>
                  {detailItems?.length > 1 &&
                    detailItems
                      .slice(1)
                      .map(
                        (
                          {
                            mark_class,
                            apply_type,
                            notice_register_product = [],
                            none_register_product = [],
                          },
                          idx
                        ) => (
                          <tr key={idx}>
                            <td colSpan={3}>
                              <div className="row">
                                <span>
                                  <span style={{ fontWeight: "bold" }}>
                                    {mark_class}류/&nbsp;
                                  </span>
                                  <span
                                    style={{
                                      fontWeight: "bold",
                                      color:
                                        apply_type === "FAST_SEARCH"
                                          ? "#3AB548"
                                          : apply_type === "SEARCH"
                                            ? "#2EAEAE"
                                            : apply_type === "FAST"
                                              ? "#F66F6F"
                                              : apply_type === "NORMAL"
                                                ? "#D08126"
                                                : "#3AB548",
                                    }}
                                  >
                                    {apply_type === "NORMAL"
                                      ? "일반"
                                      : apply_type === "SEARCH"
                                        ? "조사"
                                        : apply_type === "FAST"
                                          ? "신속"
                                          : "신속조사"}
                                    출원
                                  </span>
                                  <button
                                    onClick={() => {
                                      setEditAddProduct({
                                        kind_code: mark_class,
                                        apply_type,
                                        notice_register_product,
                                        none_register_product,
                                      });
                                      changeState(
                                        setModal,
                                        "applicationType",
                                        true
                                      );
                                    }}
                                  >
                                    수정
                                  </button>
                                  <button
                                    onClick={() => {
                                      setAlert(`confirmDelete/${mark_class}`);
                                      commonModalSetting(
                                        setAlertBox,
                                        true,
                                        "confirm",
                                        "정말 삭제하시겠습니까?"
                                      );
                                    }}
                                  >
                                    삭제
                                  </button>
                                  <br />
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      style={{
                                        fontWeight: "bold",
                                        marginTop: "10px",
                                      }}
                                    >
                                      고시 상품
                                    </div>
                                    <div
                                      style={{
                                        margin: "10px 0 10px 0",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "5px",
                                        alignItems: "center",
                                      }}
                                    >
                                      -{" "}
                                      {notice_register_product.map(
                                        (e, index) => (
                                          <span
                                            style={{
                                              padding: "5px",
                                              border: "1px solid #ccc",
                                              backgroundColor: "#fff",
                                              borderRadius: "5px",
                                              fontSize: "12px",
                                            }}
                                            key={index}
                                          >
                                            {e}
                                          </span>
                                        )
                                      )}{" "}
                                    </div>
                                    <div
                                      style={{
                                        color: "red",
                                        fontWeight: "bold",
                                        marginTop: "10px",
                                      }}
                                    >
                                      비고시 상품
                                    </div>
                                    <div
                                      style={{
                                        margin: "10px 0 10px 0",
                                        display: "flex",
                                        flexWrap: "wrap",
                                        gap: "5px",
                                        alignItems: "center",
                                        fontSize: "12px",
                                      }}
                                    >
                                      -{" "}
                                      {none_register_product.map((e, index) => (
                                        <span
                                          style={{
                                            padding: "5px",
                                            border: "1px solid #ccc",
                                            backgroundColor: "#fff",
                                            borderRadius: "5px",
                                          }}
                                          key={index}
                                        >
                                          {e}
                                        </span>
                                      ))}{" "}
                                    </div>
                                  </div>
                                </span>
                              </div>
                            </td>
                          </tr>
                        )
                      )}
                </tbody>
              </table>
            </div>
            <h5>출원인 정보</h5>
            {RenderApplicantInfo()}

            <button
              style={{
                width: "100%",
                marginTop: "90px",
                fontSize: "24px",
                height: "65px",
              }}
              onClick={handleSubmit}
            >
              신규 등록
            </button>
          </div>
        </div>
      </div>
      {edit.markImage && (
        <MarkImageNameEditModal
          setEdit={setEdit}
          markType={markType}
          isNew={isNew}
          setOriginalFileName={setOriginalFileName}
          fileName={fileName}
          setFile={setFile}
          setImg={setImg}
          setImagePath={setImagePath}
          setFileName={setFileName}
          originalFileName={originalFileName}
          setUploadComplete={setUploadComplete}
          imagePath={imagePath}
          defaultMarkNameArr={markNameArr}
          onMarkNameUpdated={(updated) => setMarkNameArr(updated)}
          setMarkType={setMarkType}
          file={file}
          img={img}
        />
      )}

      {modal.applicationType && (
        <AddApplicationTypeModal
          setModal={setModal}
          isNew={isNew}
          editAddProduct={editAddProduct}
          setEditAddProduct={setEditAddProduct}
          addDetailItem={addDetailItem}
          onSuccess={() => {
            // getPaymentTempList();
          }}
        />
      )}
      {alertBox.bool && (
        <CommonModal
          setModal={setAlertBox}
          modal={alertBox}
          okFn={() => {
            if (alert === "logout") navigate("/");
            else if (alert.includes("confirmDelete"))
              removeDetailItem(alert.split("/")[1]);
            else if (alert.includes("confirmNavigate"))
              navigate("/agencies");
            else return;
          }}
        />
      )}
    </>
  );
};

export default AddApplicationDetail;
